import { render } from "./ArticleEditorComponent.vue?vue&type=template&id=69d5d4d6"
import script from "./ArticleEditorComponent.vue?vue&type=script&lang=js"
export * from "./ArticleEditorComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__